import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "gfu-payment-form" }
const _hoisted_2 = { class: "gfu-box-actions" }
const _hoisted_3 = { class: "gfu-box-actions__item" }
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  class: "_ml-1",
  "data-qa": "create-order-btn:Back"
}
const _hoisted_6 = { class: "gfu-box-actions__item _ml-a" }
const _hoisted_7 = { "data-qa": "create-order-btn:Price" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_create_order_without_payment = _resolveComponent("create-order-without-payment")
  const _component_project_benefits_and_risks = _resolveComponent("project-benefits-and-risks")
  const _component_guest_checkout_fieldset = _resolveComponent("guest-checkout-fieldset")
  const _component_digital_delivery_checkbox_field = _resolveComponent("digital-delivery-checkbox-field")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip_button = _resolveComponent("tooltip-button")
  const _component_payment_info_box = _resolveComponent("payment-info-box")
  const _component_adyen_order_payment_options = _resolveComponent("adyen-order-payment-options")
  const _component_adyen_payment_context_provider = _resolveComponent("adyen-payment-context-provider")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_adyen_payment_context_provider, _normalizeProps(_guardReactiveProps($options.paymentConfiguration)), {
      default: _withCtx(() => [
        (!$options.isOrderPayable)
          ? (_openBlock(), _createBlock(_component_create_order_without_payment, {
              key: 0,
              "order-code": $props.orderCode,
              "anti-forgery-token": $props.antiForgeryToken,
              "form-action": $props.formAction,
              "back-action": $props.backAction,
              "validation-message": $props.validationMessage,
              "is-valid": $props.isValid,
              "has-digital-items": $props.hasDigitalItems,
              "require-accept-digital-delivery": $props.requireAcceptDigitalDelivery,
              "order-stage": $props.orderStage
            }, null, 8 /* PROPS */, ["order-code", "anti-forgery-token", "form-action", "back-action", "validation-message", "is-valid", "has-digital-items", "require-accept-digital-delivery", "order-stage"]))
          : ($options.isOrderPayable)
            ? (_openBlock(), _createBlock(_component_adyen_order_payment_options, {
                key: 1,
                "project-id": _ctx.projectContext.projectID,
                "project-phase": _ctx.projectContext.project.phase,
                "project-type": _ctx.projectContext.project.type,
                "is-instant": true,
                "stored-card": $props.storedCard,
                "checkout-mode": $props.checkoutMode,
                "effective-payable-amount": $props.effectivePayableAmount,
                "order-code": $props.orderCode,
                "order-validation-id": $props.orderCode,
                "payment-type": $props.paymentType,
                reason: $props.reason,
                "is-in-test-mode": $props.isInTestMode,
                "is-guest": $setup.guestCheckout.isUnauthenticated,
                "has-digital-items": $props.hasDigitalItems,
                "user-email": $setup.guestCheckout.userEmail,
                onPaymentError: $setup.paymentAnalytics.trackPaymentError,
                onPaymentMethodChange: $setup.paymentAnalytics.trackPaymentMethodChange,
                onTogglePaymentGroupVisibilityChange: $setup.paymentAnalytics.trackPaymentGroupVisibilityToggle,
                "data-qa": "payment-section"
              }, {
                content: _withCtx(() => [
                  _createVNode(_component_project_benefits_and_risks, {
                    class: "_mb-6",
                    "is-stretch-pay-visible": false
                  }),
                  ($setup.guestCheckout.areFieldsVisible)
                    ? (_openBlock(), _createBlock(_component_guest_checkout_fieldset, {
                        key: 0,
                        "model-value": $setup.guestCheckout.model,
                        "read-only": $setup.guestCheckout.areFieldsReadOnly
                      }, null, 8 /* PROPS */, ["model-value", "read-only"]))
                    : _createCommentVNode("v-if", true),
                  ($props.requireAcceptDigitalDelivery)
                    ? (_openBlock(), _createBlock(_component_digital_delivery_checkbox_field, {
                        key: 1,
                        modelValue: $data.digitalDeliveryAccepted,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.digitalDeliveryAccepted) = $event)),
                        name: "digitalDeliveryAccepted"
                      }, null, 8 /* PROPS */, ["modelValue"]))
                    : _createCommentVNode("v-if", true)
                ]),
                actions: _withCtx(({ onSubmit, isProceedPaymentBlocked, paymentMethodErrorMessage, isProcessing: isPaymentOptionsProcessing, grantOrderAccess }) => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      ($options.isBackButtonVisible)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "gfu-link gfu-link--accent",
                            href: $props.backAction,
                            onClick: _cache[1] || (_cache[1] = $event => ($options.onBackButtonClick($props.backAction, $event)))
                          }, [
                            _createVNode(_component_base_icon, {
                              name: "chevron-left",
                              class: "_fl _lhb"
                            }),
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Resources.Checkout.CheckoutGoBackLink), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_4))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_tooltip_button, {
                        "tooltip-text": $options.getTooltipText(isProceedPaymentBlocked, paymentMethodErrorMessage),
                        enabled: !$options.isPaymentButtonDisabled(isProceedPaymentBlocked, isPaymentOptionsProcessing || $data.isProcessing),
                        onClick: _withModifiers($event => ($options.handleSubmit(onSubmit, grantOrderAccess)), ["prevent"]),
                        "data-qa": "create-order-btn:Submit"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.Resources.Checkout.CheckoutPayButton) + " ", 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_7, _toDisplayString($options.amount), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["tooltip-text", "enabled", "onClick"]),
                      _createVNode(_component_payment_info_box, { "payment-type": $props.paymentType }, null, 8 /* PROPS */, ["payment-type"])
                    ])
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["project-id", "project-phase", "project-type", "stored-card", "checkout-mode", "effective-payable-amount", "order-code", "order-validation-id", "payment-type", "reason", "is-in-test-mode", "is-guest", "has-digital-items", "user-email", "onPaymentError", "onPaymentMethodChange", "onTogglePaymentGroupVisibilityChange"]))
            : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 16 /* FULL_PROPS */)
  ]))
}